document.addEventListener("DOMContentLoaded", function() {
    var mon_products = [];
    var list_products = [];
    var product_title_prefix = '';
    var disable_letter_breakdown = false;
    var paginate = null;
    var main_product_list = null;
    const buttonList = document.querySelector('.group-links')
    var products_list = document.querySelector('.products-list-wrapper')

    function initCollectionList(activeAlphaButton) {
      // console.log('running initCollectionList, activeAlphaButton:', activeAlphaButton)
      mon_products = [];
      list_products = [];
      product_title_prefix = '';
      disable_letter_breakdown = false;
      paginate = null;
      main_product_list = null;

      main_product_list = document.querySelector('.main-product-list');
      if (!main_product_list) return;

      product_title_prefix = main_product_list.dataset.product_title_prefix;
      disable_letter_breakdown = main_product_list.dataset.disable_letter_breakdown == "true";

      // product_titles comes from section main-collection-product-list.liquid
      const has_product_info = document.querySelector('#has_product_info');
      let prod_titles = JSON.parse(has_product_info.dataset.product_titles);
      // console.log('prod_titles', prod_titles, typeof prod_titles)
      let prod_handles = JSON.parse(has_product_info.dataset.product_handles);
      let prod_full_titles = JSON.parse(has_product_info.dataset.product_full_titles);
      mon_products = prod_titles.map((title, index) => {
        let _title = title.replace(product_title_prefix, '').trim()
        return {
          title: _title,
          beginsWith: _title[0],
          handle: prod_handles[index],
          full_title: prod_full_titles[index]
        }
      });
      // console.log('mon_products', mon_products)

      setGroups();
      buildProductList();

      if (activeAlphaButton) {
        const activeButton = document.querySelector(`[data-group_link=${activeAlphaButton}]`)
        paginate = JSON.parse(main_product_list.dataset.paginate);
        if (paginate.pages === 1) {
          console.log('one page')
          buttonList.classList.remove('waiting');
          products_list.classList.remove('waiting');
          if (activeButton) activeButton.click();
        }
         
        updateDisplayedCount(activeButton)
        
      }
      

      // load from rest of pages after load, to have less impact on CLS
      window.onload = (e) => {
        // console.log(e)
        continueLoading(activeAlphaButton);
      }

    }
    initCollectionList();

    function updateDisplayedCount(activeAlphaButton) {
      if (!activeAlphaButton) return;
      // console.log('activeAlphaButton in updateDisplayedCount', activeAlphaButton)
      const is_show_all = activeAlphaButton.dataset.group_link === 'all';
      const count = activeAlphaButton.dataset.group_count;
      const desktop_count_el = document.querySelector('#ProductCountDesktop');
      const total_count = desktop_count_el.dataset.all_products_count;
      const results_count = desktop_count_el.dataset.products_count;
      const mobile_count_el = document.querySelectorAll('.mobile-results-drawer-count');
      let count_text = desktop_count_el.textContent.trim();
      // console.log('count_text::', count_text)
      let split_text = count_text.split(' ')
      // console.log('split_text', split_text)

      let new_string;
      // if current state
      if (count_text.indexOf('/') === -1) {
        // console.log('count_text has no /')
        if (is_show_all) {
          new_string = `${results_count} ${split_text[1]}`
        } else {
          new_string = `${count}/${total_count} ${split_text[1]}`
        }
        
        desktop_count_el.textContent = new_string;
        mobile_count_el.forEach(el => el.textContent = new_string)
        return;
      }
      // else get first number
      const split_text_num = count_text.split('/')
      if (is_show_all) {
        // if no filters are on
        if (total_count == results_count) {
          new_string = `${total_count} ${split_text[1]}`
        } else {
          new_string = `${results_count}/${total_count} ${split_text[1]}`
        }
        
      } else {
        new_string = `${count}/${split_text_num[1]}`
      }
      
      desktop_count_el.textContent = new_string;
      mobile_count_el.forEach(el => el.textContent = new_string)
    }

    async function continueLoading(activeAlphaButton) {
      paginate = JSON.parse(main_product_list.dataset.paginate);
      // console.log('paginate', paginate)
      if (paginate.pages === 1) {
        buttonList.classList.remove('waiting');
        products_list.classList.remove('waiting');
        if (activeAlphaButton) {
          const activeButton = document.querySelector(`[data-group_link=${activeAlphaButton}]`)
          activeButton.click();
        }
        
        return;
      }

      // make an array on the object to map to
      paginate.remainingPages = []
      for (let pg = 2; pg <= paginate.pages; pg++) {
        paginate.remainingPages.push(pg)
      }
      // console.log('paginate', paginate)

      //LoadMoreProducts(paginate.remainingPages)
      fetchDataForItems(paginate.remainingPages)
        .then(results => {
          // console.log('All data fetched successfully:', results);
          // 'results' will be an array containing the JSON data for each item
          buttonList.classList.remove('waiting')
          products_list.classList.remove('waiting');
          // console.log('activeAlphaButton', activeAlphaButton)
          if (activeAlphaButton) { 
            const activeButton = document.querySelector(`[data-group_link="${activeAlphaButton}"]`)
            // console.log('activeButton !', activeButton)
            activeButton.click();
            updateDisplayedCount(activeButton)
          }
        })
        .catch(error => {
          console.error('One or more fetch requests failed:', error);
        });
      

      /* for (let pg = 2; pg <= paginate.pages; pg++) {
        console.log('pg vs paginate.pages', pg, ' ', paginate.pages)
        LoadMoreProducts(pg)
      } */

    }


    function fetchDataForItems(items) {
      // Map each item in the array to a fetch promise (fetch returns a promise)
      const fetchPromises = items.map(page => {
        let c_handle = main_product_list.dataset.collection;
        let section_id = 'products-list-alphabetical-json';
        let page_url = new URL(window.location);
        let page_url_params = page_url.search;
        if (!page_url_params) page_url_params = '?'
        
        // console.log('page_url_params', page_url_params)
        let url = `/collections/${ c_handle }${page_url_params}&page=${ page }&sections=${ section_id }&`
        // console.log('fetch url!!!!', url)
        return fetch(url)
          .then(response => {
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json(); // Parse the response as JSON
          })
          .then(res => {
            if (!res[section_id]) return;
            // console.log('res@!!', res)

            let parser = new DOMParser();
            let $section = parser.parseFromString(res[section_id], 'text/html').body.querySelector('[data-products]');
            // console.log($section)

            let products_tmp = [...mon_products, JSON.parse($section.dataset.products)].flat();
            products_tmp = [...new Map(products_tmp.map(p => [p.handle, p])).values()];
            products_tmp.sort((a, b) => a.title.toLowerCase() > b.title.toLowerCase() ? 1 : -1);
            // console.log('mon_products:::', mon_products)
            let groups = [...new Set(products_tmp.map(p => p.beginsWith))].sort();
            // console.log('groups:::', groups) 

            list_products = groups.map((group) => {
              return {
                beginsWith: group,
                products: mon_products.filter(p => p.beginsWith == group).sort()
              }
            })
            // console.log('list_products:::', list_products)


            mon_products = products_tmp;
            paginate = JSON.parse($section.dataset.paginate);
            setGroups();
            buildProductList();
            // console.log(paginate);

            document.dispatchEvent(new CustomEvent('products_loaded'));

          })
          .catch(error => {
            console.error(`Error fetching data for item ${page}:`, error);
            // Return a rejected promise or a specific error object if needed
            throw error; // Re-throw the error to propagate it
          });
      });

      // Use Promise.all to wait for all fetch promises to resolve
      return Promise.all(fetchPromises);
    }


    /* async function LoadMoreProducts(page, last, activeAlphaButton) {
      console.log('running LoadMoreProducts')
      let c_handle = main_product_list.dataset.collection;
      let section_id = 'products-list-alphabetical-json';
      let page_url = new URL(window.location);
      let page_url_params = page_url.search;
      if (!page_url_params) page_url_params = '?'
      // console.log('page_url_params', page_url_params)
      let url = `/collections/${ c_handle }${page_url_params}&page=${ page }&sections=${ section_id }&`
      // console.log(url)

      let res = await fetch(url).then(res => res.json());
      if (!res[section_id]) return;

      let parser = new DOMParser();
      let $section = parser.parseFromString(res[section_id], 'text/html').body.querySelector('[data-products]');
      // console.log($section)

      let products_tmp = [...mon_products, JSON.parse($section.dataset.products)].flat();
      products_tmp.sort((a, b) => a.title.toLowerCase() > b.title.toLowerCase() ? 1 : -1);
      // console.log('mon_products:::', mon_products)
      let groups = [...new Set(products_tmp.map(p => p.beginsWith))].sort();
      // console.log('groups:::', groups) 

      list_products = groups.map((group) => {
        return {
          beginsWith: group,
          products: mon_products.filter(p => p.beginsWith == group).sort()
        }
      })
      // console.log('list_products:::', list_products)


      mon_products = products_tmp;
      paginate = JSON.parse($section.dataset.paginate);
      setGroups();
      buildProductList();
      console.log(paginate);

      if (last) buttonList.classList.remove('waiting')
      console.log('last', last)
      console.log('activeAlphaButton', activeAlphaButton)
      if (last && activeAlphaButton) { 
        const activeButton = document.querySelector(`[data-group_link="${activeAlphaButton}"]`)
        // console.log('activeButton !', activeButton)
        activeButton.click();
        
      }
    } */


    function setGroups() {
      // console.log('running setGroups')
      let list_products_tmp = [];
      if (disable_letter_breakdown) {
        list_products_tmp = [{
          beginsWith: '',
          products: mon_products.sort()
        }];
      }
      else {
        // console.log('mon_products:', mon_products)
        // let groups = [...new Set(mon_products.map(p => {p.beginsWith}))].sort();
        let groups = [...new Set(mon_products.map(p => {
          const isNumber = !isNaN(parseInt(p.beginsWith));
          if (isNumber) {
            return p.beginsWith = 1
          } else {
            return p.beginsWith
          }
          
        }))].sort();
        // console.log('groups:::', groups)
        list_products_tmp = groups.map((group) => {
          return {
            beginsWith: group,
            products: mon_products.filter(p => p.beginsWith == group).sort()
          }
        });
        // console.log('list_products::', list_products)
      }
      list_products = list_products_tmp;
      // console.log('list_products in setGroups', list_products)
    }


    function updateGroupFilterSearchParams(group_button) {
      // console.log('running updateGroupFilterSearchParams')
      // Create a new URL object
      let url = new URL(window.location.href);

      // Get the alpha_group, if there is one
      let alpha_group = url.searchParams.get('alpha_group');

      // If there's an alpha_group...
      if (alpha_group && group_button.dataset.group_link === 'all') {
        // if show all, delete param
        url.searchParams.delete('alpha_group');
        history.replaceState(history.state, '', url.href);
        return;
      }
      // else
      url.searchParams.set('alpha_group', group_button.dataset.group_link);
      window.history.pushState(null, '', url.toString());
    }

    function updateFilterSummary(group_button) {
      const facet_summaries = document.querySelectorAll('.filters-summary .active-facets')
      // console.log('facet_summaries',facet_summaries);
      facet_summaries.forEach(el => {
        // remove any letter button that was already there
        const remove_group_link = el.querySelector('.remove-group-link');
        if (remove_group_link) remove_group_link.remove();

        if (group_button.dataset.group_link === 'all') {
          document.dispatchEvent(new CustomEvent('letter_filter_cleared'));
          return;
        };

        // make new remove button
        // build BUTTON
        const fragment_button = document.createDocumentFragment();

        // get button
        const removeButtonTemplate = document.querySelector('#remove-group-button')
        // console.log('removeButtonTemplate', removeButtonTemplate)
        const removeButtonContent = removeButtonTemplate.content.cloneNode(true);
        // console.log('removeButtonContent', removeButtonContent)

        const x_button = removeButtonContent.querySelector('button')
        x_button.dataset.remove_group = group_button.dataset.group_link
        const button_letter = group_button.dataset.group_link.replace('group_', '')
        const remove_group_text = removeButtonContent.querySelector('.remove-group-text');
        remove_group_text.textContent = button_letter

        fragment_button.appendChild(removeButtonContent);

        // append the html 
        el.appendChild(fragment_button);
        //  document.dispatchEvent(new CustomEvent('letter_filter_added'));
        const filters_header = document.querySelectorAll('.filters-summary .filter-heading-wrap')
        if (filters_header.length > 0) filters_header.forEach(el => {el.classList.remove('has-active-filters-0')})
      })
    }
    function groupFilter(group, group_button) {
      // console.log('running groupFilter')
      const all_groups = document.querySelectorAll('.group-alphabetized');
      const all_buttons = document.querySelectorAll('.group-links button');

      all_buttons.forEach(el => el.classList.remove('active'));
      const current_button = document.querySelector(`.link_${group} button`);
      current_button.classList.add('active');

      if (group === 'all') {
        all_groups.forEach(el => el.style.display = 'block');
        updateDisplayedCount(group_button)
        updateGroupFilterSearchParams(group_button);
        updateFilterSummary(group_button);
        return;
      }
      all_groups.forEach(el => el.style.display = 'none');
      const show_this = document.querySelector(`#${group}`)
      show_this.style.display = 'block';

      // update url
      updateGroupFilterSearchParams(group_button);

      //add 'remove' link to filter summaries
      updateFilterSummary(group_button);

      updateDisplayedCount(group_button)
    }

    document.addEventListener('collection_updated', () => {
      // console.log('heard collection_updated in collection-products-list.js')
      let activeAlphaButton = '';
      activeAlphaButton = document.querySelector('.group-link.active')?.dataset.group_link;
      if (activeAlphaButton === 'all') activeAlphaButton = '';
      
      buttonList.classList.add('waiting')
      products_list.classList.remove('waiting');

      initCollectionList(activeAlphaButton);
      setTimeout(() => {
          continueLoading(activeAlphaButton)
        }, 10);
      
    })
    /* document.addEventListener('refresh_list', () => {
      console.log('heard refresh_list')
      initCollectionList();
    }) */
    document.addEventListener('click', (e) => {
      const check_group_link = e.target.closest('button.group-link')
      if (!check_group_link) return;
      const group = check_group_link.dataset.group_link;
      groupFilter(group, check_group_link);
    })
    document.addEventListener('click', (e) => {
      const remove_group_link = e.target.closest('button.remove-group-link')
      if (!remove_group_link) return;
      e.preventDefault();
      const remove_group_buttons = document.querySelectorAll('.filters-summary .remove-group-link')
      if (!remove_group_buttons.length > 0) return;
      remove_group_buttons.forEach(el => el.remove());
      
      const show_all = document.querySelector('[data-group_link="all"]')
      show_all.click();
      document.dispatchEvent(new CustomEvent('letter_filter_cleared'));
      //groupFilter(group, check_group_link);

    })
    

    function buildProductList() {
      // console.log('running buildProductList')

      // build BUTTON list
      const buttons_list = document.querySelector('.group-links')
      const fragment_buttons = document.createDocumentFragment();

      // get "All" button
      const firstButtonTemplate = document.querySelector('#link_all')
      const firstButtonContent = firstButtonTemplate.content.cloneNode(true);

      fragment_buttons.appendChild(firstButtonContent);

      // loop through groups to get the remaining buttons
      const buttonTemplate = document.querySelector('#group-button')

      // console.log('list_products', list_products)
      for (let group of list_products) {
        // console.log('group in buildProductList', group)
        const clonedContent = buttonTemplate.content.cloneNode(true);
        const li = clonedContent.querySelector('li');
        const button = clonedContent.querySelector('button');

        li.classList.add(`link_group_${group.beginsWith}`);
        button.dataset.group_link = `group_${group.beginsWith}`;
        button.dataset.group_count = `${group.products.length}`;
        group.beginsWith === 1 ? button.textContent = '#' : button.textContent = group.beginsWith;

        fragment_buttons.appendChild(clonedContent);
      }

      // append the html
      buttons_list.innerHTML = ''
      buttons_list.appendChild(fragment_buttons);




      // build PRODUCT list
      products_list = document.querySelector('.products-list-wrapper')
      products_list.classList.add('waiting')
      const fragment_products = document.createDocumentFragment();

      // loop through groups 
      const alphaTemplate = document.querySelector('#group-alphabetized')
      for (let group of list_products) {
        const clonedContent = alphaTemplate.content.cloneNode(true);
        const group_alphabetized = clonedContent.querySelector('.group-alphabetized');
        const letter = clonedContent.querySelector('.letter');
        const ul = clonedContent.querySelector('ul.list-products');

        group_alphabetized.id = `group_${group.beginsWith}`;
        group.beginsWith === 1 ? letter.textContent = '#' : letter.textContent = group.beginsWith;


        const productTemplate = document.querySelector('#letter-products')
        for (let product of group.products) {
          const clonedContent = productTemplate.content.cloneNode(true);
          const link = clonedContent.querySelector('a');
          const title = clonedContent.querySelector('.product-item-title');

          link.href = `/products/${product.handle}`;
          // link.title = product.full_title;
          title.textContent = product.title;

          ul.appendChild(clonedContent);
        }

        fragment_products.appendChild(clonedContent);
      }

      // append the html
      products_list.innerHTML = ''
      products_list.appendChild(fragment_products);

    }
document.addEventListener('products_loaded', () => {
  let url = new URL(window.location.href);
  let alpha_group = url.searchParams.get('alpha_group');
  if (alpha_group) {
    const alpha_button = document.querySelector(`[data-group_link="${alpha_group}"]`)
    if (alpha_button) alpha_button.click();
  }
})
});